"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Keyline = exports.KEYLINE_WIDTH_PROPERTY_NAME = exports.KEYLINE_HEIGHT_PROPERTY_NAME = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokens = require("@smartsheet/design-tokens");
var _react = _interopRequireWildcard(require("react"));
var _spacing = require("../../../constants/spacing");
var _useTheme = require("../../../theme/utils/useTheme");
var _scrollAreaTheme = require("../scrollAreaTheme");
var _resolveGutterLength = require("../utils/resolveGutterLength");
const KEYLINE_WIDTH_PROPERTY_NAME = `--smar--lodestar-core--keyline-width-as9dpu`;
exports.KEYLINE_WIDTH_PROPERTY_NAME = KEYLINE_WIDTH_PROPERTY_NAME;
const KEYLINE_HEIGHT_PROPERTY_NAME = `--smar--lodestar-core--keyline-height-as9dpu`;
exports.KEYLINE_HEIGHT_PROPERTY_NAME = KEYLINE_HEIGHT_PROPERTY_NAME;
const Keyline = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    alignTop,
    direction = "vertical",
    ...props
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  return /*#__PURE__*/_react.default.createElement(KeylineStyled, (0, _extends2.default)({}, props, {
    ref: ref,
    alignment: alignTop ? "start" : "end",
    themeMode: themeMode,
    direction: direction
  }));
});
exports.Keyline = Keyline;
Keyline.displayName = "Keyline";
const KeylineStyled = (0, _styled.default)("div", {
  shouldForwardProp: propName => {
    switch (propName) {
      case "direction":
      case "alignment":
      case "gutter":
      case "themeMode":
      case "includeScrollingIndication":
      case "isVisible":
      case "isScrolling":
        return false;
      default:
        return true;
    }
  }
})`
    position: absolute;
    pointer-events: none;

    ${_ref2 => {
  let {
    direction,
    alignment
  } = _ref2;
  switch (alignment) {
    case "start":
      return direction === "vertical" ? `top: 0` : `left: 0`;
    case "end":
      return direction === "vertical" ? `bottom: 0` : `right: 0`;
  }
}};

    margin-left: ${_ref3 => {
  let {
    direction,
    gutter
  } = _ref3;
  // Don't support gutter in horizontal mode. We'd rather not support the gutter prop at all
  // since it's generally not what you want.
  if (direction === "horizontal") {
    return "none";
  }
  switch (gutter) {
    case "none":
      return "0px";
    case "legacy":
      return `${_spacing.sizes.xLarge}px`;
    default:
      return (0, _resolveGutterLength.resolveGutterLength)(gutter);
  }
}};

    //Animate the rendering of the keyline
    opacity: ${_ref4 => {
  let {
    isVisible
  } = _ref4;
  return isVisible ? 1 : 0;
}};
    transition: opacity ${_designTokens.motion.animation.default};

    height: var(${KEYLINE_HEIGHT_PROPERTY_NAME}, auto);
    width: var(${KEYLINE_WIDTH_PROPERTY_NAME}, auto);

    // This hides this element, but allows the box-shadow to still be visible.
    overflow: hidden;

    // This provides the box-shadow for the keyline.
    &::before {
        content: "";
        display: block;

        transform: ${getTransform};
        box-shadow: ${getBoxShadow};

        // TODO use tokens for this
        transition: box-shadow 450ms cubic-bezier(0.3, 0.3, 0.2, 1) 0s, margin 450ms cubic-bezier(0.3, 0.3, 0.2, 1) 0s,
            width 450ms cubic-bezier(0.3, 0.3, 0.2, 1) 0s, height 450ms cubic-bezier(0.3, 0.3, 0.2, 1) 0s;
        opacity: ${_ref5 => {
  let {
    isVisible
  } = _ref5;
  return isVisible ? 1 : 0;
}};

        // This dimension length allows the box-shadow to be properly offset from its parent.
        // This value depends on the box-shadow's blur and offset values.
        ${_ref6 => {
  let {
    direction,
    isScrolling,
    includeScrollingIndication
  } = _ref6;
  switch (direction) {
    case "vertical":
      return `
                        height: 16px;
                        width: ${isScrolling && includeScrollingIndication ? "calc(100% - 8px)" : "100%"};
                        margin-left: ${isScrolling && includeScrollingIndication ? "4px" : "0"};
                    `;
    case "horizontal":
      return `
                        height: ${isScrolling && includeScrollingIndication ? "calc(100% - 8px)" : "100%"};
                        width: 16px;
                        margin-top: ${isScrolling && includeScrollingIndication ? "4px" : "0"};
                    `;
  }
}}
    }
`;
function getBoxShadow(_ref7) {
  let {
    themeMode,
    alignment,
    direction,
    isScrolling,
    includeScrollingIndication
  } = _ref7;
  return includeScrollingIndication && isScrolling ? _scrollAreaTheme.scrollAreaTheme.keyline[alignment].boxShadow[direction].scrolling(themeMode) : _scrollAreaTheme.scrollAreaTheme.keyline[alignment].boxShadow[direction].rest(themeMode);
}
function getTransform(_ref8) {
  let {
    direction,
    alignment
  } = _ref8;
  switch (direction) {
    case "vertical":
      return alignment === "start" ? "translateY(-16px)" : "translateY(16px)";
    case "horizontal":
      return alignment === "start" ? "translateX(-16px)" : "translateX(16px)";
  }
}
//# sourceMappingURL=Keyline.js.map